import {
  encode,
  decode,
  uploadImage,
  fetchConsultants,
  db,
  storage,
} from './firebase'

export const hideConsultant = consultantId =>
  db.ref(`user-info/${consultantId}/hidden`).set(true)

export const approveConsultant = consultantId =>
  db.ref(`user-info/${consultantId}/listed`).set(true)

export const fetchUnlistedConsultants = () => fetchConsultants()

export const fetchConsultant = (consultantId, force) =>
  fetchConsultants(force).then(consultants => consultants.get(consultantId))

const mapUserInfo = userInfo => ({
  ...userInfo,
  interests: Object.keys(userInfo.interests || {}).map(interest =>
    decode(interest)
  ),
  titles: Object.keys(userInfo.titles || {}).map(title => decode(title)),
})

export const fetchUserInfo = id =>
  db
    .ref(`user-info/${id}`)
    .once('value')
    .then(snapshot => snapshot.val())
    .then(
      userInfo =>
          userInfo.profilePicture &&
          userInfo.profilePicture.startsWith('images')
            ? storage
                .ref(userInfo.profilePicture)
                .getDownloadURL()
                .catch(err => {
                  // Hack: If the thumbnail is not (yet) ready, just use the full frame
                  // TODO: Listen to the storage and use the thumbnail when its ready
                  if (err.code === 'storage/object-not-found') {
                    return storage
                      .ref(userInfo.profilePictureFull)
                      .getDownloadURL();
                  } else {
                    throw err;
                  }
                })
                .then(profilePicture => ({
                  ...userInfo,
                  profilePicture,
                }))
                .catch(err => {
                  console.err(`Could not fetch profile picture ${err}`);
                  return userInfo
                })
            : Promise.resolve(userInfo)
    )
    .then(mapUserInfo)

export const updateConsultantInterests = (consultantId, interests) =>
  db.ref(`/user-info/${consultantId}/interests`).set(
    interests.reduce(
      (interests, interest) => ({
        ...interests,
        [encode(interest)]: true,
      }),
      {}
    )
  )

export const updateConsultantStartDate = (consultantId, startDate) =>
  db.ref(`/user-info/${consultantId}/startDate`).set(startDate)

const updateUser = (
  consultantId,
  { name, employer, titles, availability, profilePicture, dateOfBirth, mobile }
) => {
  let newData = {}

  if (titles && titles.length) {
    newData.titles = titles.reduce(
      (titles, title) => ({
        ...titles,
        [encode(title)]: true,
      }),
      {}
    )
  }

  if (name) newData.name = name
  if (employer) newData.employer = employer
  if (availability) newData.availability = availability
  if (profilePicture) {
    newData.profilePicture = profilePicture.thumb;
    newData.profilePictureFull = profilePicture.full;
  }
  if (dateOfBirth) newData.dateOfBirth = dateOfBirth
  if (mobile) newData.mobile = mobile

  return db
    .ref(`/user-info/${consultantId}`)
    .update(newData)
    .then(() => fetchUserInfo(consultantId))
}

export const updateUserInfo = (
  consultantId,
  { name, employer, titles, availability, profilePicture, dateOfBirth, mobile }
) =>
  profilePicture
    ? uploadImage(profilePicture).then(path =>
        updateUser(consultantId, { name, employer, titles, availability, dateOfBirth, mobile, profilePicture: path })
      )
    : updateUser(consultantId, { name, employer, titles, availability, dateOfBirth, mobile })



// WEBPACK FOOTER //
// ./src/api/consultants.js